/* eslint-disable max-params */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* eslint-disable no-undef */
import { disableAnalytics } from '@config';

const env = process.env.REACT_APP_ENV;
const isDev = env === 'dev'
const isProd = env === 'prod'

const loadAdroll = () => {
  ((w, d) => {
    w.adroll_adv_id = 'QD6YHCDFUNCTVMM656KQBK';
    w.adroll_pix_id = 'JJBURLEZKFHLPMAMB7L5W6';
    w.adroll_version = '2.0';

    w.__adroll_loaded = true;
    w.adroll = w.adroll || [];
    w.adroll.f = ['setProperties', 'identify', 'track'];
    const roundtripUrl = `https://s.adroll.com/j/${adroll_adv_id}/roundtrip.js`;
    for (let a = 0; a < w.adroll.f.length; a++) {
      w.adroll[w.adroll.f[a]] =
        w.adroll[w.adroll.f[a]] ||
        (function (n) {
          return function () {
            // eslint-disable-next-line prefer-rest-params
            w.adroll.push([n, arguments]);
          };
        })(w.adroll.f[a]);
    }

    const adScript = d.createElement('script');
    const [firstScript] = d.getElementsByTagName('script');
    adScript.async = 1;
    adScript.src = roundtripUrl;
    firstScript.parentNode.insertBefore(adScript, firstScript);
  })(window, document);

  adroll.track('pageView');
};

const loadHotjar = () => {
  const id = env === 'prod' ? 3058211 : 3014448;
  (function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:id,hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}

export const loadScripts = () => {
  if (!disableAnalytics && isProd) {
    loadAdroll();
  }
  if (!disableAnalytics && (isDev || isProd)) {
    loadHotjar();
  }
};
